import type { DefaultOptionType } from "antd/es/select";

import BlockedUserName from "../components/BlockedUserName";
import UserModel from "../viewModels/Settings/UserModel";

export type UserSelectOptionType = DefaultOptionType & { name: string };

export const createUserSelectOption = (user: UserModel): UserSelectOptionType => {
  return {
    value: user.id,
    label: <BlockedUserName name={user.fullName} locked={user.locked} />,
    name: user.fullName,
  };
};

export const filterUserSelectOption = (input: string, option?: { name?: string }): boolean => {
  return (option?.name ?? "").toLowerCase().includes(input.toLowerCase());
};
